import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalysisManager } from '../../../../managers/analysis.manager';
import { Issue } from '../../../../models/ui/issue.model';
import { NotificationManager } from '../../../../managers/notification.manager';

@Component({
	selector: 'lex-modify-issue-dialog',
	templateUrl: './modify-issue-dialog.component.html',
	styleUrls: ['./modify-issue-dialog.component.scss'],
	standalone: false
})
export class ModifyIssueDialogComponent implements OnInit {
	public issueFormGroup: UntypedFormGroup;
	public currentIssue: Issue;
	public addOrEditText: string;

	constructor(private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<ModifyIssueDialogComponent>,
		private analysisManager: AnalysisManager,
		private notificationManager: NotificationManager,
		@Inject(MAT_DIALOG_DATA) data: Issue
	) {
		if (data) {
			this.currentIssue = data;
			this.addOrEditText = 'Edit';
		} else {
			this.currentIssue = new Issue();
			this.addOrEditText = 'Add';
		}
	}

	ngOnInit(): void {
		this.issueFormGroup = this.formBuilder.group({
			issueTitle: [this.currentIssue.title, [Validators.required, Validators.maxLength(256)]],
			description: [this.currentIssue.description, [Validators.maxLength(1024)]]
		});
	}

	public ok(): void {
		this.currentIssue.title = this.issueFormGroup.controls['issueTitle'].value;
		this.currentIssue.description = this.issueFormGroup.controls['description'].value;
		this.analysisManager.saveIssue({ issue: this.currentIssue }).subscribe({
			next: () => {
				this.analysisManager.refreshIssues();
				this.analysisManager.refreshFacts();
				this.analysisManager.setSelectedIssue(null);
				this.notificationManager.displaySnackBarMessage({ message: `Issue saved successfully.` });
				this.dialogRef.close();
			},
			error: () => {
				this.notificationManager.displaySnackBarMessage({ message: `An error occurred in the process of saving your Issue. Please verify your update is saved, and try again if your edits are unsaved.` });
				this.dialogRef.close();
			}
		});
	}

	public cancel(): void {
		this.analysisManager.refreshIssues();
		this.analysisManager.refreshFacts();
		this.analysisManager.setSelectedIssue(null);
		this.dialogRef.close();
	}
}
